/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Password_KeepInputs */

const cs_sreality_password_keep = /** @type {(inputs: Sreality_Password_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nechte prázdné, pokud chcete ponechat uložený software key / heslo.`)
};

const en_sreality_password_keep = /** @type {(inputs: Sreality_Password_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave blank to keep the stored software key / password.`)
};

/**
* | output |
* | --- |
* | "Leave blank to keep the stored software key / password." |
*
* @param {Sreality_Password_KeepInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_password_keep = /** @type {((inputs?: Sreality_Password_KeepInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Password_KeepInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_password_keep(inputs)
	return cs_sreality_password_keep(inputs)
});